import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

export type DataRow = {
    id: number;
    name: string;
    is_for_legal_age: 'sim' | 'não' | boolean | '';
};

export type Category = DataRow;

type CategoryResponse = {
    data: Array<Category & { id: string }>;
};

export const KEY_LIST_CATEGORY = 'KEY_LIST_CATEGORY';

const getCategory = async () => {
    const response = await api.get<CategoryResponse>(`/category`, {
        params: {
            page: 1,
            perPage: 100,
        },
    });
    return response.data.data;
};

export const useGetCategory = () => {
    return useQuery({
        queryFn: () => getCategory(),
        queryKey: [KEY_LIST_CATEGORY],
        refetchOnWindowFocus: false,
    });
};
